import { Styles, css } from '@flipster/styled-system/css';
import { isNullable } from '@flipster/utils/nullable';
import { getOrdinalNumber } from '@flipster/utils/num';

interface Props {
  value?: number;
  max?: number;
  css?: Styles;
}

export const OrdinalNumber = ({ value, max, css: cssProps }: Props) => {
  if (isNullable(value)) return <span className={css(cssProps)}>-</span>;

  const { suffix } = getOrdinalNumber(value);

  return (
    <span className={css(cssProps)}>
      <span>{value}</span>
      {(!max || value <= max) && <span className={css({ ml: 2 })}>{suffix}</span>}
    </span>
  );
};
